"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inquiry() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="inquirycalltoaction" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_office_interior.png)] opacity-10" />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-36 text-center md:py-48 lg:py-[200px]">
        {}
        <div ref={labelRef} className={`mb-16 transition-all duration-700 ease-out md:mb-20 ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs tracking-[0.25em] text-secondary uppercase">
            THE NEXT STEP
          </span>
        </div>

        {}
        <h2 ref={headingRef} className={`mt-2 font-serif font-default text-foreground leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontFamily: "var(--font-serif)",
        fontWeight: 400,
        fontSize: "clamp(2.5rem, 8vw, 5rem)"
      }}>Discuss an Attorney's Fee Matter</h2>

        {}
        <p ref={bodyRef} className={`mt-12 max-w-[560px] text-base leading-relaxed text-foreground/70 transition-all duration-1000 delay-150 ease-out md:mt-14 md:text-lg ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontFamily: "var(--font-sans)"
      }}>If you are seeking an expert witness in an attorney's fee matter, the initial discussion begins with the available billing records, court filings, scheduling requirements, and the issues presented by the fee application.</p>

        {}
        <div ref={ctaRef} className={`mt-16 flex flex-col items-center gap-6 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-8 md:mt-20 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="sm" variant="outline" className="group h-auto rounded-lg border border-foreground/30 bg-background px-6 py-3 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground">
            <Link to="/ContactUsPage">
              Inquire About Availability
              <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/ContactUsPage" className="group inline-flex items-center gap-2 border-b border-foreground/40 pb-1 text-sm font-medium tracking-wide text-foreground transition-colors hover:border-foreground">
            Contact the Office
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}